export default {
    oldpassword_label: 'Old Password',
    newpassword_label: 'New Password',
    confirmpassword_label: 'Confrim New Password',
    title_pwd: 'Modify Password',
    confirm_btn: 'Confrim',
    return_btn: 'Return',
    oldpassword_placeholder: 'Please enter your old password',
    newpassword_placeholder: 'Please enter your new password',
    confirmpassword_placeholder: 'Please re-enter your new password',
    title_info: 'Modify Personal Infomation',
    nickname_label: 'Nick Name',
    email_label: 'Email',
    mobile_label: 'Mobile',
    nickname_placeholder: 'please enter your nickname',
    email_placeholder: 'please enter your email correctly',
    mobile_placeholder: 'Please enter your mobile phone correctly.'
  }


// WEBPACK FOOTER //
// ./src/i18n/en-us/modifyInfo.js